module.exports = __webpack_public_path__ + "img/school3.85fd9ce9.jpg";